/* eslint-disable camelcase */

export default (api) => {

    function getDashboard(durationValue) {
        return api.get(`/_svc/slapi-v1/dashboard?durationValue=${durationValue}`);
    }

    return {
        getDashboard,
    };
};



// WEBPACK FOOTER //
// ./src/services/DashboardService.js